import { api } from '../api';

export const versionApi = api.injectEndpoints({
  endpoints: build => ({
    getBackendVersion: build.query({
      query: () => ({
        url: 'api/version',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetBackendVersionQuery } = versionApi;
